export const SKELETON_VARIANTS = {
  text: 'text',
  circular: 'circular',
  rectangular: 'rectangular',
}

export const SKELETON_ANIMATIONS = {
  pulse: 'pulse',
  wave: 'wave',
}
